import { Box } from "@mui/material";
import Image from "next/image";
import { Brand } from "@/core/types/types";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { ExtendedTheme } from "@/core/components/Theme";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";

const styles = (theme: ExtendedTheme) => ({
  root: {
    marginTop: theme.spacing(3),
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: "20px",
    margin: "24px 0px 16px",
    fontWeight: 700,
  },
  container: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  imageWrapper: {
    width: "88px",
    height: "88px",
    borderRadius: "50%",
  },
});

interface HumanFaceComponentProps {
  brandName: Brand;
}

export const HumanFaceComponent = ({ brandName }: HumanFaceComponentProps) => {
  const classes: any = useCustomStyles(styles);

  const title = t(`common.sidebar.face.title`);
  const description = t(`common.sidebar.face.description`);

  return (
    <Box sx={classes.root}>
      <Box sx={classes.title}>{title}</Box>
      <Box sx={classes.container}>
        <Box sx={classes.imageWrapper}>
          <Image
            alt={`${brandName}-face`}
            src={`/images/faces/${brandName}/face.png`}
            width={88}
            height={88}
            style={{ borderRadius: "50%" }}
          />
        </Box>
        <Box>{description}</Box>
      </Box>
    </Box>
  );
};
